import { isProd } from 'kumba-common/src/libs/env';

// Check that service workers are registered
if ('serviceWorker' in navigator) {
  // Use the window load event to keep the page load performant
  window.addEventListener('load', () => {
    isProd() && navigator.serviceWorker.register('/sw.js');
  });
}
